(ns rothko.editor.document.transform.compound
  (:require [com.rpl.specter :as sp]
            [rothko.editor.actions :as actions]
            [rothko.editor.document.navigator :refer [selectionnav]]
            [rothko.editor.document.navigators :as n]
            [rothko.editor.mark.transform :as mark-transform]
            [rothko.editor.space.transform :as space-transform]
            [rothko.editor.edit.transform :as edit-transform]
            [rothko.editor.tag.transform :as tag-transform]))

(defn unless-empty
  [structure path]
  (if (-> structure :script empty?)
    actions/no-op
    path))

(defn unbalanced-mwe-tags-in-selection?
  [{:keys [script]
    {:keys [start-index end-index]} :selection}]
  (let [range-end-index (-> end-index inc (min (count script)))
        selected-tokens (subvec script start-index range-end-index)
        ends-with-mwe-level (reduce
                             (fn [mwe-level {:keys [name]}]
                               (case name
                                 :mwe-start (inc mwe-level)
                                 :mwe-end (dec mwe-level)
                                 mwe-level))
                             0
                             selected-tokens)]
    (not (zero? ends-with-mwe-level))))

(def remove-all-tags-and-marks
  [(sp/with-fresh-collected
     [(sp/collect-one :selection)
      (selectionnav
       []
       (transform*
        [_ selection structure next-fn]
        (sp/transform
         (unless-empty
          structure
          (sp/multi-path
           (mark-transform/delete-at selection)
           tag-transform/remove-all
           (space-transform/collapse-all selection))) ; TODO: This shouldn't be using the original selection because it can be out-of-date after the previous transform.
         next-fn
         structure)))])])

(def remove-all-mwe-tags-and-marks
  [(sp/with-fresh-collected
    [(sp/collect-one :selection)
     (selectionnav
      []
      (transform*
       [_ selection structure next-fn]
       (sp/transform
        (unless-empty
         structure
         (sp/multi-path
          (mark-transform/delete-at selection)
          (if (unbalanced-mwe-tags-in-selection? structure)
            actions/no-op
            tag-transform/remove-all)))
        next-fn
        structure)))])])

(def remove-changes
  [(sp/with-fresh-collected
    [(sp/collect-one :selection)
     (selectionnav
       []
       (transform*
        [_ selection structure next-fn]
        (sp/transform
         (unless-empty
          structure
          (sp/multi-path
           tag-transform/remove-all
           edit-transform/remove-all
           n/token-rebias))
         next-fn
         structure)))])])
